import { render, staticRenderFns } from "./wt-select.vue?vue&type=template&id=3abb311d&scoped=true"
import script from "./wt-select.vue?vue&type=script&lang=js"
export * from "./wt-select.vue?vue&type=script&lang=js"
import style0 from "./wt-select.vue?vue&type=style&index=0&id=3abb311d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abb311d",
  null
  
)

export default component.exports